import React from 'react';
import { Trans } from "@lingui/macro";
import { Tag } from 'antd';

export const FixedAssetHelper = {
    getStatus: status => {
        if (!status)
            return null;
        switch (status) {
            case 'DISPOSED':
                return <Tag color="red">{FixedAssetHelper.getStatusText(status)}</Tag>;
            case 'IN_USE': default:
                return <Tag color="green">{FixedAssetHelper.getStatusText(status)}</Tag>;
        }
    },

    getStatusText: status => {
        if (!status)
            return null;
        switch (status) {
            case 'DISPOSED':
                return <Trans>Disposed</Trans>;
            case 'IN_USE':
            default:
                return <Trans>Registered</Trans>;
        }
    },

    getDepreciationMethod: value => {
        switch (value) {
            case 'DECLINING_BALANCE_1X':
                return <Trans>Declining Balance</Trans>;
            case 'DECLINING_BALANCE_2X':
                return <Trans>Declining Balance (2x)</Trans>;
            case 'STRAIGHT_LINE':
            default:
                return <Trans>Straight Line</Trans>;
        }
    },

    getDepreciationConvention: value => {
        switch (value) {
            case 'ACTUAL_DAYS':
                return <Trans>Actual Days</Trans>;
            case 'FULL_MONTH': default:
                return <Trans>Full Month</Trans>;
        }
    },

    getDepreciateMode: value => {
        switch (value) {
            case 'RATE':
                return <Trans>Rate</Trans>;
            case 'PERIOD': default:
                return <Trans>Useful Life</Trans>;
        }
    },
};
